import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import { withStyles } from 'material-ui/styles';

import { ListItem, ListItemIcon, ListItemText  } from 'material-ui/List';
import EditIcon from 'material-ui-icons/Edit';
import Material from '../../../../models/Material';

const styles = () => ({
  link: {
    textDecoration: 'none'
  }
});

export function EditMenuItem(props) {
  const { material, onClick, classes, unit } = props;
  const displayName = material ? material.toString(unit): '';
  const text=`Edit ${displayName}`
  const url= material ? `/app/layers/${material.key}/edit` : '';
  const disabled = material === undefined;
  const listItem = (
    <ListItem button onClick={onClick} disabled={disabled}>
      <ListItemIcon>
        <EditIcon />
      </ListItemIcon>
      <ListItemText primary={text} />
    </ListItem>
  );

  if (material === undefined) {
    return listItem;
  } else {
    return (
      <div>
        <Link to={url} className={classes.link}>
          {listItem}
        </Link>
      </div>
    );
  }
}

EditMenuItem.propTypes = {
  material: PropTypes.instanceOf(Material),
  onClick:  PropTypes.func,
  unit:     PropTypes.string.isRequired,
};

export default withStyles(styles)(EditMenuItem);


// WEBPACK FOOTER //
// ./src/components/StackupDesign/Viewer/MenuDrawer/EditMenuItem.js